import { render, staticRenderFns } from "./PocketmagsPlusProductsList.vue?vue&type=template&id=5d85f3ca"
import script from "./PocketmagsPlusProductsList.vue?vue&type=script&lang=js"
export * from "./PocketmagsPlusProductsList.vue?vue&type=script&lang=js"
import style0 from "./PocketmagsPlusProductsList.vue?vue&type=style&index=0&id=5d85f3ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports